// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Button } from 'ui/Button';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import {
  useActionForOrdersMutation,
  useGetOrderQuery,
  useLazyGetTypesOfServicesQuery,
  useUpdateOrderMutation,
} from 'redux/Api/ordersApi/ordersApi';
import { OrderSteps } from 'components/OrderSteps';
import { OrderCondition } from 'components/OrderCondition';
import { OrderExecutor } from 'components/OrderExecutor';
import { OrderDocuments } from 'components/OrderDocuments';
import { setInfoDateHourMinutes, setInfoOrderDetail } from 'redux/ordersDetails/slice';
import { Layout } from 'features/Layouts/Layouts';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { WhiteBlock } from 'components/WhiteBlock';
import { InformationOrderBlock } from 'components/InformationOrderBlock';
import { DocumentInfo } from 'components/DocumentInfo';
import { Title } from 'components/Title';
import { EditFieldsOrder } from 'components/EditFieldsOrder';
import { ReactComponent as BackBtn } from './img/iconChewronForward.svg';
import { getDateFormattedDateInfo } from 'utils/date';
import { downloadFileForOrders } from 'api/getApi';
import { NewOrderDetailsHistory } from 'components/NewOrderDetailsHistory';
import { Nothing } from 'components/Nothing';
import { OrderActionBtn } from 'components/OrderActionBtn';
import styles from './OrdersDetails.module.scss';
import { AppTooltip } from 'ui/AppTooltip';
import { useOrderValidation } from 'pages/CreateOrder/hooks/useOrderValidation';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import { ModalCancelOrder } from '../../components/ModalCancelOrder/index';
import { SuccessErrorInfo } from 'components/SuccessErrorInfo';
import { Modal } from 'components/Modal';
import modalStyles from './WorkerContentModal.module.scss';
import { ActionRequiredAlertDetales } from './ActionRequiredAlertDetales';
import { echo } from 'App';
import { OrderAgreement } from 'components/OrderAgreement';
import { ValueOrderAgreement } from 'redux/Api/ordersApi/type';
import { getAuthorizationHeader } from 'redux/Api/employedsApi/employedsApi';

const isProduction = process.env.NODE_ENV === 'production';

export const OrdersDetails = () => {
  const { id } = useParams();
  const role = localStorage.getItem('role');
  const phone = localStorage.getItem('phone');
  const navigate = useNavigate();
  const [modalMessage, setModalMessage] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [disableAgreement, setDisableAgreement] = useState(true);
  const [step, setStep] = useState<number>(0);
  const [apiError, setApiError] = useState<string | null>(null);
  const [isShowCancelModal, setIsShowCancelModal] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [disableAgreementButton, setDisableAgreementButton] = useState(false);
  const [contractLimit, setContractLimit] = useState<number | null>(null);
  const [selectedDocument, setSelectedDocument] = useState<null | string>(null);
  const { balance, infoPercent } = useSelector((state: RootState) => state.authSlice);
  const { infoOrderDetail } = useSelector((state: RootState) => state.ordersDetailsSlice);
  const [valueOrderAgreement, setValueOrderAgreement] = useState<ValueOrderAgreement>({
    accept_automatically: 0,
    include_tax_amount: 0,
    unit_volume: infoOrderDetail?.unit_volume,
    amount: +infoOrderDetail?.amount,
    unit_price: infoOrderDetail?.unit_price,
  });
  const [showButtonChat, setShowButtonChat] = useState(null);
  const [chatHistoryExists, setChatHistoryExists] = useState(null);

  const [textErrorValueOrderAgreement, setTextErrorValueOrderAgreement] = useState<
    string | null
  >(null);
  const [amountErrorOrderAgreement, setAmountErrorOrderAgreement] = useState<
    string | null
  >(null);

  const clearAmountErrorOrderAgreement = useCallback(() => {
    setAmountErrorOrderAgreement(null);
  }, []);

  const validateConfirmVolume = useCallback(() => {
    if (!valueOrderAgreement.amount || Number(valueOrderAgreement.amount) <= 0) {
      setAmountErrorOrderAgreement('Обязательное поле');
      return false;
    }

    setAmountErrorOrderAgreement(null);
    return true;
  }, [valueOrderAgreement.amount]);

  useEffect(() => {
    if (valueOrderAgreement.unit_volume < infoOrderDetail.unit_volume_min) {
      return setTextErrorValueOrderAgreement('Меньше лимита');
    }
    if (
      infoOrderDetail.unit_volume_max &&
      valueOrderAgreement.unit_volume > infoOrderDetail.unit_volume_max
    ) {
      return setTextErrorValueOrderAgreement('Больше лимита');
    }
    return setTextErrorValueOrderAgreement(null);
  }, [valueOrderAgreement.unit_volume, infoOrderDetail.unit_volume_max]);

  const [getTypes, { data: dataTypes, isLoading: isLoadingTypes }] =
    useLazyGetTypesOfServicesQuery();
  const { data: pollingData } = useGetOrderQuery({ id });

  const fetchChatHistoryExists = async (retryOnUnauthorized = true) => {
    if (!isProduction) {
      return;
    }

    const currentChatToken = localStorage.getItem('chatToken');

    if (!currentChatToken) {
      return;
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_CHAT_URL}/api/customer_cabinet/chat_history_exists/${id}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${currentChatToken}`,
          },
        },
      );

      if (res.status === 401 && retryOnUnauthorized) {
        const tokenRes = await fetch(
          `${process.env.REACT_APP_API_URL}/api/chat/get-access-token`,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              Authorization: getAuthorizationHeader(),
            },
          },
        );
        const tokenData = await tokenRes.json();
        if (tokenData?.token) {
          localStorage.setItem('chatToken', tokenData.token);
          await new Promise((resolve) => setTimeout(resolve, 300));
          return fetchChatHistoryExists(false);
        }
        return;
      }

      const responseData = await res.json();
      setChatHistoryExists(responseData.chat_history_exists);
    } catch (error) {
      console.log('Ошибка при получении истории чата:', error);
    }
  };

  useEffect(() => {
    if (pollingData?.id) {
      fetchChatHistoryExists();
    }
  }, [pollingData?.id]);

  useEffect(() => {
    setValueOrderAgreement({
      accept_automatically: pollingData?.accept_automatically ?? 0,
      include_tax_amount: pollingData?.include_tax_amount ?? 0,
      unit_volume: pollingData?.order_data?.unit_volume || 0,
      amount: +pollingData?.order_data?.amount || 0,
      unit_price: pollingData?.order_data?.unit_price || 0,
    });

    if (
      pollingData?.status?.value === 'worker_set_volume' &&
      pollingData?.order_data?.worker_set_volume &&
      pollingData?.order_data?.worker_set_volume?.unit_volume &&
      pollingData?.order_data?.worker_set_volume?.amount
    ) {
      setValueOrderAgreement({
        ...valueOrderAgreement,
        unit_volume: pollingData?.order_data?.worker_set_volume?.unit_volume,
        amount: +pollingData?.order_data?.worker_set_volume?.amount,
      });
      setShowBanner(true);
    } else {
      setShowBanner(false);
    }
    setShowButtonChat(pollingData?.can_make_chat);
  }, [pollingData]);

  const minMaxPrice =
    phone === '9052264047' || phone === '79052264047'
      ? { min: 50, max: 100000 }
      : { min: 1000, max: 50000 };

  const { data, isLoading, error, refetch } = useGetOrderQuery({ id }, { skip: false });

  const showAllert = useMemo(() => {
    return (
      data?.status?.value === 'payment_success' &&
      data?.docs?.[2]?.number === 'Чек (аннулирован)'
    );
  }, [data]);

  const updateStatusHandler = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/worksupport/orders/${id}/sync-deal-status`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        },
      );
      const data = await response.json();

      if (response.ok) {
        setModalMessage('Данные успешно обновлены');
        setModalOpen(true);
      } else if (data.message === 'У заказа нет сделки') {
        setModalMessage(data.message);
        setModalOpen(true);
      } else {
        setModalMessage('Данные не обновились');
        setModalOpen(true);
      }
    } catch {
      setModalMessage('Внутренняя ошибка сервера');
      setModalOpen(true);
    }
  };

  const orderData = pollingData || data;

  const [updateOrder, { error: errorUpdateOrder, isLoading: loadingUpdateOrder }] =
    useUpdateOrderMutation();

  const [actionForOrdersMutation, { error: errorAction }] = useActionForOrdersMutation();

  const { errors, validateFields, validateEmployee, clearErrorForField } =
    useOrderValidation();

  const {
    worker_id,
    description,
    amount,
    is_remote,
    city: cityInfoOrderDetail,
    street: streetInfoOrderDetail,
  } = infoOrderDetail || {};
  const errorCountDescription = (description || '').length > 3000;

  const syncedOrderIdRef = useRef<string | undefined>(undefined);
  const syncedServerWorkerIdRef = useRef<number | null | undefined>(undefined);

  useEffect(() => {
    if (orderData) {
      const serverWorkerId = orderData?.worker?.id ?? null;
      const orderChanged = syncedOrderIdRef.current !== orderData.id;
      const serverWorkerChanged = syncedServerWorkerIdRef.current !== serverWorkerId;

      // Не затираем локально выбранного исполнителя при refetch без воркера на бэке
      if (orderChanged || serverWorkerChanged) {
        dispatch(setInfoOrderDetail({ key: 'worker_id', value: serverWorkerId }));
        syncedOrderIdRef.current = orderData.id;
        syncedServerWorkerIdRef.current = serverWorkerId;
      }

      if (orderData?.status?.value !== 'order_draft') {
        if (orderData?.is_remote) {
          dispatch(
            setInfoOrderDetail({
              key: 'is_remote',
              value: 'Удаленно',
            }),
          );
          dispatch(
            setInfoOrderDetail({
              key: 'with_address',
              value: false,
            }),
          );
        } else {
          const city = (orderData?.order_data?.city || '').trim();
          const street = (orderData?.order_data?.street || '').trim();
          const home = (orderData?.order_data?.home || '').trim();
          const hasAddress = city.length > 0 || street.length > 0 || home.length > 0;

          dispatch(
            setInfoOrderDetail({
              key: 'is_remote',
              value: hasAddress ? 'По адресу' : 'Удаленно',
            }),
          );
          dispatch(
            setInfoOrderDetail({
              key: 'with_address',
              value: hasAddress,
            }),
          );
        }
      }

      if (orderData?.include_tax_amount !== undefined) {
        dispatch(
          setInfoOrderDetail({
            key: 'add_tax_amount',
            value:
              orderData?.include_tax_amount === 1 ||
              orderData?.order_data?.include_tax_amount === 1,
          }),
        );
      }
      if (orderData?.accept_automatically !== undefined) {
        dispatch(
          setInfoOrderDetail({
            key: 'accept_automatically',
            value: orderData?.accept_automatically || 0,
          }),
        );
      }
      if (orderData?.use_fast_withdraw !== undefined) {
        dispatch(
          setInfoOrderDetail({
            key: 'use_fast_withdraw',
            value: orderData?.use_fast_withdraw || 0,
          }),
        );
      }
      if (orderData?.city !== undefined) {
        dispatch(
          setInfoOrderDetail({
            key: 'city',
            value: orderData?.city === 1 || orderData?.order_data?.city === 1,
          }),
        );
      }
      if (orderData?.street !== undefined) {
        dispatch(
          setInfoOrderDetail({
            key: 'street',
            value: orderData?.street === 1 || orderData?.order_data?.street === 1,
          }),
        );
      }
      if (orderData?.home !== undefined) {
        dispatch(
          setInfoOrderDetail({
            key: 'home',
            value: orderData?.home === 1 || orderData?.order_data?.home === 1,
          }),
        );
      }
      if (orderData?.apartment !== undefined) {
        dispatch(
          setInfoOrderDetail({
            key: 'apartment',
            value: orderData?.apartment === 1 || orderData?.order_data?.apartment === 1,
          }),
        );
      }
      if (orderData?.order_data?.date_start !== undefined) {
        dispatch(
          setInfoOrderDetail({
            key: 'date_start',
            value: orderData?.order_data?.date_start,
          }),
        );
      }

      if (orderData?.order_data?.date_end !== undefined) {
        dispatch(
          setInfoOrderDetail({ key: 'date_end', value: orderData?.order_data?.date_end }),
        );
      }

      for (const key in orderData?.order_data) {
        if (key === 'date_start' || key === 'date_end') {
          if (orderData.order_data[key] > 1) {
            dispatch(
              setInfoOrderDetail({
                key,
                value: getDateFormattedDateInfo(orderData.order_data[key].split(' ')[0]),
              }),
            );
            dispatch(
              setInfoDateHourMinutes({
                key,
                value: orderData.order_data[key].split(' ')[1],
              }),
            );
          }
        } else {
          dispatch(setInfoOrderDetail({ key, value: orderData.order_data[key] }));
        }
      }
    }
  }, [orderData, dispatch]);

  useEffect(() => {
    if (role === 'director' && id) {
      getTypes();
    }
  }, [id, role]);

  const updateOrderHandler = async (isDraft) => {
    if (errorCountDescription) {
      return;
    }

    if (!validateFields()) {
      return;
    }

    const {
      date_start,
      date_end,
      amount,
      is_remote,
      accept_automatically,
      add_tax_amount,
      with_date_start,
      use_fast_withdraw,
      contract_kind,
      ...rest
    } = infoOrderDetail;
    await updateOrder({
      id,
      body: {
        ...rest,
        date_end: moment(date_end || new Date()).format('YYYY-MM-DD 00:00'),
        date_start: with_date_start
          ? moment(date_start || new Date()).format('YYYY-MM-DD 00:00')
          : null,
        amount: +amount,
        is_remote: is_remote === 'Удаленно' ? true : false,
        is_draft: isDraft,
        accept_automatically: accept_automatically === 1 ? 1 : 0,
        include_tax_amount: add_tax_amount ? 1 : 0,
        use_fast_withdraw: use_fast_withdraw ? 1 : 0,
        ...(contract_kind && { unified_contract_type: contract_kind }),
      },
    });
  };

  const {
    home = '',
    street = '',
    city = '',
    apartment = '',
    ...obj
  } = orderData?.order_data || {};
  const objectInfo = {
    ...obj,
    address: orderData?.is_remote
      ? 'Удалённая работа'
      : `${city || ''} ${street || ''} ${home || ''} ${apartment || ''}`,
  };

  const downloadFile = async (elem) => {
    setSelectedDocument(elem.type);
    try {
      setDownloadLoading(true);
      const response = await downloadFileForOrders(role === 'worksupport' && role, id, {
        type: elem.type,
      });

      if (!response.data) {
        throw new Error('Ошибка при загрузке файла');
      }

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);

      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.download = elem.number;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();

      // Открываем файл в новой вкладке
      window.open(url, '_blank');
      // Освобождаем ресурсы URL
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
    } finally {
      setDownloadLoading(false);
      setSelectedDocument(null);
    }
  };

  const arrStatus = [
    'order_success',
    'moderation_in_progress',
    'moderation_success',
    'worker_failed',
    'worker_success',
    'worker_approved_by_customer',
    'worker_invited_by_customer',
    'worker_rejected_by_customer',
    'worker_approved_order',
    'order_published',
  ];

  const isCanceled = useMemo(() => {
    return arrStatus.some((e: string) => e === orderData?.status?.value);
  }, [orderData?.status]);

  const { ...objPayment } = orderData?.payment || {};

  useEffect(() => {
    if (errorUpdateOrder || errorAction) {
      setApiError(errorUpdateOrder?.data?.message || errorAction?.data?.message);
    }
  }, [errorUpdateOrder, errorAction]);

  const actionWithOrder = async (url) => {
    try {
      await actionForOrdersMutation({ url });
    } catch (error) {
      console.log('error', error);
    }
  };

  const sumWithPercent = +infoOrderDetail.amount * (infoPercent.commission_percent / 100);

  const disabledBtnPercent =
    +balance <
    (sumWithPercent < infoPercent.commission_min_amount
      ? +infoOrderDetail.amount + infoPercent.commission_min_amount
      : +infoOrderDetail.amount + +sumWithPercent.toFixed(2));

  const lengthAmount = 60;

  const formatedHistory = useMemo(() => {
    const groupHistory = {};

    orderData?.history?.forEach((elem: any) => {
      const { datetime, ...rest } = elem;
      if (!datetime || typeof datetime !== 'string') return;

      const dateSlice = datetime.split(' ').slice(0, 2).join(' ');

      if (!groupHistory[dateSlice]) {
        groupHistory[dateSlice] = {
          datetime: dateSlice,
          items: [],
        };
      }

      groupHistory[dateSlice].items.push({
        date: datetime.split(' ').slice(2).join(''),
        ...rest,
      });
    });

    const consolidatedHistory = Object.values(groupHistory);
    return consolidatedHistory;
  }, [orderData]);

  useEffect(() => {
    if (error?.status === 404) navigate(`/orders`);
  }, [error]);

  useEffect(() => {
    if (!id) return;

    let channel: any = null;

    const handleOrderChanged = (data: any) => {
      if (!data) return;
      refetch();
    };

    try {
      channel = echo.private(`orders.${id}`);
      channel.listen('.order.changed', handleOrderChanged);
    } catch (error) {
      console.error('Failed to setup WebSocket listener:', error);
    }

    return () => {
      if (channel) {
        try {
          echo.leave(`orders.${id}`);
        } catch (error) {
          console.error('Failed to cleanup WebSocket listener:', error);
        }
      }
    };
  }, [id, refetch]);

  const showBlockAgreement = useMemo(() => {
    if (
      orderData?.order_data?.is_unit_based === 1 &&
      (orderData?.status?.value === 'order_canceled' ||
        orderData?.status?.value === 'order_canceled_by_platform')
    ) {
      return true;
    }
    return orderData?.order_data?.is_unit_based === 1 && step > 3;
  }, [orderData?.order_data?.is_unit_based, step, orderData?.status?.value]);

  return (
    <Layout>
      <Helmet>
        <title>Заказ</title>
      </Helmet>
      {(!String(balance) && role === 'director') ||
      isLoading ||
      isLoadingTypes ||
      loadingUpdateOrder ||
      error?.status === 500 ? (
        error ? (
          <Nothing style={{ marginTop: '30px' }} title='Ошибка, попробуйте позже' />
        ) : (
          <LoadingSkeleton fullWidth />
        )
      ) : role === 'worksupport' ? (
        <div className={styles.root}>
          <div className={styles.back}>
            <p className={styles.back_title}>
              {orderData?.is_draft
                ? 'Карточка заказа'
                : `Заказ №${orderData?.number}
                `}
            </p>
            <div style={{ display: 'flex' }}>
              {orderData?.status?.value !== 'order_canceled_by_platform' &&
                orderData?.status?.value !== 'payment_success' &&
                orderData?.status?.value !== 'order_canceled' &&
                orderData?.status?.value !== 'order_draft' && (
                  <Button
                    className={styles.cancel_btn}
                    theme='outline'
                    onClick={() => setIsShowCancelModal(true)}>
                    Отменить платформой
                  </Button>
                )}
              <Button
                className={styles.update_btn}
                theme='outline'
                onClick={() => updateStatusHandler()}>
                Обновить статус сделки
              </Button>
              {modalOpen && (
                <Modal setOpen={setModalOpen}>
                  <div className={modalStyles.root}>
                    <Title className={modalStyles.title} title='Уведомление' />
                    <p className={modalStyles.message}>{modalMessage}</p>
                    <div className={modalStyles.buttons}>
                      <Button
                        onClick={() => setModalOpen(false)}
                        className={modalStyles.button}>
                        Закрыть
                      </Button>
                    </div>
                  </div>
                </Modal>
              )}
            </div>

            {role !== 'worksupport' && (
              <OrderActionBtn
                disabledBtnPercent={disabledBtnPercent}
                worker_id={worker_id}
                data={orderData}
                description={description}
                amount={amount}
                isCanceled={isCanceled}
                id={id}
                actionWithOrder={actionWithOrder}
                updateOrderHandler={(isDraft) => updateOrderHandler(isDraft)}
                minMaxPrice={minMaxPrice}
                balance={balance}
                is_remote={is_remote}
                city={cityInfoOrderDetail}
                street={streetInfoOrderDetail}
              />
            )}
          </div>
          <div className={styles.content}>
            <div className={styles.rootleft}>
              {orderData?.is_draft && role === 'director' ? (
                <div>
                  <EditFieldsOrder
                    draft={orderData?.is_draft}
                    types={dataTypes}
                    minMaxPrice={minMaxPrice}
                    balance={+balance >= +amount}
                    infoPercent={infoPercent}
                    sumBalance={+balance}
                  />
                </div>
              ) : (
                <div className={styles.left}>
                  <Title title='Данные заказа' />
                  <InformationOrderBlock objectInfo={objectInfo} />
                </div>
              )}
              {!!orderData?.docs.length && (
                <div className={styles.left}>
                  <Title title='Документы' />
                  <div className={styles.blockDocs}>
                    {orderData?.docs?.map((elem, i) => (
                      <DocumentInfo
                        loading={selectedDocument === elem?.type && downloadLoading}
                        onClick={() => downloadFile(elem)}
                        key={i}
                        href={''}
                        number={elem?.number}
                        date={elem?.created_at}
                      />
                    ))}
                  </div>
                </div>
              )}

              {!!orderData?.history?.length && (
                <WhiteBlock style={{ paddingRight: '4px' }}>
                  <Title title='История' />
                  <div className={styles.root_history}>
                    {formatedHistory?.map((elem: any, ind: number) => (
                      <div className={styles.root_block} key={ind}>
                        <Title
                          className={styles.root_history_title}
                          title={elem.datetime}
                        />
                        {elem.items.map((item, i) => {
                          const isOverflowing = item.text?.length > lengthAmount;
                          const titleText = isOverflowing
                            ? `${item.text.slice(0, lengthAmount)}...`
                            : item.text;

                          return (
                            <div className={styles.root_block_text} key={i}>
                              <div className={styles.root_text}>
                                <AppTooltip
                                  label={item.text}
                                  disabled={!isOverflowing}
                                  position='bottom'
                                  offset={8}
                                  arrowPosition='center'>
                                  <div>
                                    <Title
                                      style={{
                                        fontWeight: 400,
                                        fontSize: '16px',
                                        lineHeight: '24px',
                                      }}
                                      title={titleText}
                                    />
                                  </div>
                                </AppTooltip>
                              </div>
                              <p className={styles.root_datetext}>{item.date}</p>
                            </div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                </WhiteBlock>
              )}
            </div>

            <div className={styles.right}>
              <NewOrderDetailsHistory
                status={orderData?.status}
                payment={orderData?.payment}
                objPayment={objPayment}
                data={orderData}
                role={role}
                actionWithOrder={actionWithOrder}
                id={id}
                isCanceled={isCanceled}
                beneficiary={orderData?.beneficiary}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.root}>
          <Link to='/orders' className={styles.backBtn}>
            <BackBtn />
            Назад к заказам
          </Link>
          {showAllert && (
            <>
              <div style={{ paddingTop: '10px', maxWidth: '1558px' }}>
                <ActionRequiredAlertDetales
                  dateStr={
                    orderData?.last_fns_receipt?.is_canceled &&
                    orderData?.last_fns_receipt?.cancellation_date
                  }
                />
              </div>
            </>
          )}
          <OrderSteps
            saveOrder={() => updateOrderHandler(false)}
            saveDraft={() => updateOrderHandler(true)}
            setDisableAgreement={setDisableAgreement}
            disableAgreement={disableAgreement}
            valueOrderAgreement={valueOrderAgreement}
            validateConfirmVolume={validateConfirmVolume}
            validateEmployee={validateEmployee}
            setStep={setStep}
            disableAgreementButton={disableAgreementButton}
            showButtonChat={Boolean(showButtonChat || chatHistoryExists)}
          />
          <div className={styles.wrapper} style={{ marginBottom: '200px' }}>
            <OrderCondition errors={errors} clearErrorForField={clearErrorForField} />

            <div className={styles.info}>
              {showBlockAgreement ? (
                <OrderAgreement
                  setValueOrderAgreement={setValueOrderAgreement}
                  valueOrderAgreement={valueOrderAgreement}
                  disableAgreement={disableAgreement}
                  textErrorValueOrderAgreement={textErrorValueOrderAgreement}
                  amountErrorOrderAgreement={amountErrorOrderAgreement}
                  clearAmountErrorOrderAgreement={clearAmountErrorOrderAgreement}
                  selectedWorker={orderData?.worker ?? null}
                  setDisableAgreementButton={setDisableAgreementButton}
                  contractLimit={contractLimit}
                  showBanner={showBanner}
                />
              ) : null}
              <OrderExecutor
                errors={errors}
                setContractLimit={setContractLimit}
                details={true}
                clearErrorForField={clearErrorForField}
              />
              {!!data?.docs && <OrderDocuments />}
            </div>
          </div>
        </div>
      )}
      {isShowCancelModal && (
        <ModalCancelOrder
          isShowCancelModal={isShowCancelModal}
          setIsShowCancelModal={setIsShowCancelModal}
          orderId={id}
        />
      )}
      {apiError && (
        <SuccessErrorInfo
          type='error'
          text={apiError}
          handleClose={() => setApiError(null)}
        />
      )}
    </Layout>
  );
};
